/* Refillia: pagina profumo e profumatori. Equivalente che si gira, formati o fragranze, ricerca di un altro equivalente */
(function () {
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function avvia(sez) {
    if (sez.dataset.rfptPronta) return;
    sez.dataset.rfptPronta = '1';

    /* equivalente */
    var eq = sez.querySelector('[data-rfpt-eq]');
    if (eq) {
      var apri = eq.querySelector('[data-rfpt-eq-apri]'), chiudi = eq.querySelector('[data-rfpt-eq-chiudi]');
      apri.addEventListener('click', function () { eq.classList.add('aperto'); apri.setAttribute('aria-expanded', 'true'); chiudi.focus({ preventScroll: true }); });
      chiudi.addEventListener('click', function () { eq.classList.remove('aperto'); apri.setAttribute('aria-expanded', 'false'); apri.focus({ preventScroll: true }); });
    }

    /* formati o fragranze */
    var scelte = sez.querySelector('[data-rfpt-scelte]');
    var campo = sez.querySelector('[data-rfpt-id]'), add = sez.querySelector('[data-rfpt-add]');
    var foto = sez.querySelector('[data-rfpt-foto]');
    function scegli(b, primo) {
      scelte.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      campo.value = b.dataset.id;
      var pronto = b.dataset.pronto === '1';
      add.disabled = !pronto;
      var t = add.querySelector('[data-rfpt-add-t]');
      if (!add.dataset.testo) add.dataset.testo = t.innerHTML;
      if (pronto) {
        t.innerHTML = add.dataset.testo;
        var pa = t.querySelector('[data-rfpt-add-prezzo]');
        if (pa) pa.textContent = b.dataset.prezzo;
      } else {
        t.textContent = 'Non disponibile';
      }
      var pz = sez.querySelector('[data-rfpt-prezzo]');
      if (pz) pz.textContent = b.dataset.prezzo;
      var scelta = sez.querySelector('[data-rfpt-scelta]');
      if (scelta && b.dataset.titolo) scelta.textContent = b.dataset.titolo;
      var fr = sez.querySelector('[data-rfpt-fragranza]');
      if (fr && b.dataset.titolo) fr.textContent = b.dataset.titolo;
      var nb = sez.querySelector('[data-rfpt-note-box]');
      if (nb && b.dataset.titolo !== undefined) {
        var note = (b.dataset.note || '').replace(/ e /g, ', ').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
        nb.hidden = !note.length;
        sez.querySelector('[data-rfpt-note]').innerHTML = note.map(function (n) { return '<i>' + esc(n) + '</i>'; }).join('');
      }
      if (foto && b.dataset.img && foto.dataset.src !== b.dataset.img) {
        var im = new Image();
        im.onload = function () { foto.removeAttribute('srcset'); foto.src = b.dataset.img; foto.dataset.src = b.dataset.img; };
        im.src = b.dataset.img;
      }
      if (!primo) { try { var u = new URL(window.location); u.searchParams.set('variant', b.dataset.id); window.history.replaceState({}, '', u); } catch (e) {} }
    }
    if (scelte) {
      scelte.querySelectorAll('button').forEach(function (b) { b.addEventListener('click', function () { scegli(b); }); });
      var acceso = scelte.querySelector('.rfpt-fr[aria-pressed="true"]');
      if (acceso) scegli(acceso, true);
    }

    /* da telefono: pallini sotto foto e piramide */
    var gal = sez.querySelector('[data-rfpt-gal]'), punti = sez.querySelectorAll('[data-rfpt-punti] i');
    if (gal && punti.length) {
      gal.addEventListener('scroll', function () {
        var n = Math.round(gal.scrollLeft / Math.max(1, gal.clientWidth));
        punti.forEach(function (p, i) { p.classList.toggle('on', i === n); });
      }, { passive: true });
    }

    /* link alle recensioni: scorre con calma fino alla sezione */
    sez.querySelectorAll('[data-rfpt-vai-rec]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var t = document.getElementById('rf-recensioni');
        if (!t) return;
        e.preventDefault();
        t.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    /* cerca un altro equivalente: usa l'elenco della chat, o lo chiede da solo */
    var form = sez.querySelector('[data-rfpt-cerca-form]');
    if (form) {
      var q = sez.querySelector('[data-rfpt-q]'), ris = sez.querySelector('[data-rfpt-ris]');
      var aiuto = ris.innerHTML, dati = null;
      function carica() {
        if (window.RF_EQUIVALENTI) return window.RF_EQUIVALENTI();
        if (dati) return Promise.resolve(dati);
        return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + '?section_id=rf-eq')
          .then(function (r) { return r.text(); })
          .then(function (t) { var m = t.match(/<script[^>]*data-rf-eq[^>]*>([\s\S]*?)<\/script>/); dati = m ? JSON.parse(m[1]) : []; return dati; });
      }
      function norm(s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9 ]/g, ' '); }
      function trova(lista, testo) {
        if (window.RF_CERCA_EQ) return window.RF_CERCA_EQ(lista, testo);
        var parole = norm(testo).split(/\s+/).filter(function (w) { return w.length > 1; });
        return lista.filter(function (p) { var t = norm(p.o + ' ' + p.m + ' ' + p.n); return parole.every(function (w) { return t.indexOf(w) >= 0; }); });
      }
      var giro = 0;
      function cerca() {
        var v = q.value.trim(), mio = ++giro;
        if (v.length < 3) { ris.innerHTML = aiuto; return; }
        carica().then(function (lista) {
          if (mio !== giro) return;
          var t = trova(lista, v);
          if (!t.length) {
            var wa = document.querySelector('[data-rfch]');
            var num = wa ? wa.dataset.wa : '';
            ris.innerHTML = '<p class="rfpt-cerca__vuoto">Non lo troviamo tra i nostri equivalenti.' + (num ? ' <a href="https://wa.me/' + esc(num) + '?text=' + encodeURIComponent('Ciao Refillia, cerco l’equivalente di ' + v) + '" target="_blank" rel="noopener">Chiedi su WhatsApp</a>: ti diciamo il più vicino.' : '') + '</p>';
            return;
          }
          ris.innerHTML = '<p class="rfpt-cerca__conta">' + (t.length === 1 ? '1 equivalente' : t.length + ' equivalenti') + '</p><div class="rfpt-cerca__lista">' + t.map(function (p) {
            var f = '<span class="rfpt-cerca__foto">' + (p.i ? '<img src="' + esc(p.i) + '" alt="" width="48" height="48" loading="lazy">' : '') + '</span>';
            var testo = '<span><small>' + esc(p.o) + ' · ' + esc(p.m) + '</small><b>' + esc(p.n) + '</b></span>';
            return p.u ? '<a class="rfpt-cerca__r" href="' + esc(p.u) + '">' + f + testo + '<span class="rfpt-cerca__vai">Vedi</span></a>' : '<div class="rfpt-cerca__r">' + f + testo + '<span class="rfpt-cerca__arrivo">In arrivo</span></div>';
          }).join('') + '</div>';
        });
      }
      var attesa;
      q.addEventListener('input', function () { clearTimeout(attesa); attesa = setTimeout(cerca, 180); });
      q.addEventListener('focus', function () { carica(); }, { once: true });
      form.addEventListener('submit', function (e) { e.preventDefault(); cerca(); });
    }
  }

  function tutte() { document.querySelectorAll('[data-rfpt]').forEach(avvia); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tutte); else tutte();
  document.addEventListener('shopify:section:load', tutte);
})();
